
import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

//Pages
import Home from './pages/Home/Home';
import PointFlow from './pages/PointFlow/PointFlow'; 
import Configuration from './pages/Configuration/Configuration';
import RegisterPoint from './pages/RegisterPoint/RegisterPoint';
import ConfirmationPoint from './pages/ConfirmationPoint/ConfirmationPoint';
import LoginUser from './pages/LoginUser/LoginUser';
import LoginAdm from './pages/LoginAdm/LoginAdm';
import UpdatePassword from './pages/UpdatePassword/UpdatePassword';
import Loading from './pages/Loading/Loading'; 
import ReportUser from './pages/ReportUser/ReportUser'; 
import ProtocolList from './pages/ProtocolList/ProtocolList';
import CalendarPage from './pages/Calendar/Calendar'; 
import ProtocolDetails from './pages/ProtocolDetails/ProtocolDetails';

const redirectTo = () => {
  return(
        <BrowserRouter>
          <Switch>
              <Route path="/" exact={true} component={Loading} />
              <Route path="/loading" component={Loading} />
              <Route path="/report-user" component={ReportUser} />
              <Route path="/home" exact={true} component={Home} />
              <Route path="/configuration" exact={true} component={Configuration} />
              <Route path="/register-point" component={RegisterPoint} />
              <Route path="/confirmation-point" component={ConfirmationPoint} />
              <Route path="/login-user" component={LoginUser} />
              <Route path="/login-adm" component={LoginAdm} />
              <Route path="/update-password" component={UpdatePassword} /> 
              <Route path="/point-flow" component={PointFlow} /> 
              <Route path="/protocol-list" component={ProtocolList} />
              <Route path="/calendar" component={CalendarPage} /> 
              <Route path="/protocol-details" component={ProtocolDetails} /> 
            </Switch>
        </ BrowserRouter>
  ) 
}

const Routes = () => {
  return redirectTo()
}

export default Routes
